import { Tabs } from 'antd';
import React, { useState, useEffect } from 'react'
import { getOTACodes } from '../../services/common';
import AttractionsTable from './AttractionTable';
import AttractionsTabs from './AttractionTabs';


const { TabPane } = Tabs;

const Affiliation = (props: { isEditable: any, cancelEditable: any }) => {

  const [currentFlag, setCurrentFlag] = useState('table')
  const [currentLine, setCurrentLine] = useState()
  const [typeAccData, setTypeAccData] = useState<Array<any>>([])
  const [typeLayData, setTypeLayData] = useState<Array<any>>([])
  const [stateData, setStateData] = useState<Array<any>>([])
  const [transferData, setTransferData] = useState<Array<any>>([])

  // get type ACC data
  const getTypeAccData = async () => {
    let res = await getOTACodes('ACC', '')
    if (res && res.otacodes && res.otacodes.length != 0) {
      res.otacodes.map((item: any) => item.key = item.codeName)
      setTypeAccData(res.otacodes)
    } else {
      setTypeAccData([])
    }
  };

  // get type LAY data
  const getTypeLayData = async () => {
    let res = await getOTACodes('LAY', '')
    if (res && res.otacodes && res.otacodes.length != 0) {
      res.otacodes.map((item: any) => item.key = item.codeName)
      setTypeLayData(res.otacodes)
    } else {
      setTypeLayData([])
    }
  };

  // get state data
  const getStateData = async () => {
    let res = await getOTACodes('USA', '')
    if (res && res.otacodes && res.otacodes.length != 0) {
      res.otacodes.map((item: any) => item.key = item.codeName)
      setStateData(res.otacodes)
    } else {
      setStateData([])
    }
  };

  // get transfer
  const getTransferData = async () => {
    let res = await getOTACodes('TAG', '')
    if (res && res.otacodes && res.otacodes.length != 0) {
      res.otacodes.map((item: any) => item.key = item.codeName)
      setTransferData(res.otacodes)
    } else {
      setTransferData([])
    }
  };
  useEffect(() => {
    getTransferData()
    getTypeAccData()
    getTypeLayData()
    getStateData()
  }, [])

  return (
    <div>
      { currentFlag == 'table' && 
      <Tabs defaultActiveKey="1">
        <TabPane tab="Attractions Table" key="1" >
          <AttractionsTable 
            isEditable={props.isEditable} 
            cancelEditable={props.cancelEditable} 
            setCurrentFlag={setCurrentFlag} 
            currentFlag={currentFlag} 
            setCurrentLine={setCurrentLine}
          />
        </TabPane>
      </Tabs>
      }
      {
        (currentFlag == 'add' || currentFlag == 'edit' || currentFlag == 'view') && 
          <AttractionsTabs 
            isEditable={props.isEditable} 
            cancelEditable={props.cancelEditable} 
            currentFlag={currentFlag} 
            setCurrentFlag={setCurrentFlag} 
            currentLine={currentLine} 
            setCurrentLine = {setCurrentLine} 
            setTransferData={setTransferData} 
            stateData={stateData} 
            typeLayData={typeLayData} 
            typeAccData={typeAccData} 
            transferData={transferData} />
      }
    </div>
  )
}
export default Affiliation;

